/**
 * 配置编译环境和线上环境之间的切换
 *
 * mainUrl: 域名地址
 *
 */
let serverUrl;
let ossUrl;
if (process.env.NODE_ENV == 'development') {
  serverUrl = 'http://192.168.0.177:3333/'
  ossUrl = 'http://test-media-back.test176.cn' //测式网
}else{
  ossUrl = window.location.origin
  serverUrl = 'http://test-main.zhihuipk.com/'
}

export {
  serverUrl, ossUrl
}



// WEBPACK FOOTER //
// ./src/config/env.js